var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_81","data-name":"Path 81","d":"M28.875-8.25v-15.6L20.432-17.4l4.383,4.963-.129.129-5.092-4.512L16.5-14.437l-3.094-2.385L8.314-12.311l-.129-.129L12.568-17.4,4.125-23.848v15.6Zm-.516-16.5H4.641L16.5-15.727Z","transform":"translate(-4.125 24.75)","fill":"#f7f7f7"}));
}

MailInline.defaultProps = {"width":"24.75","height":"16.5","viewBox":"0 0 24.75 16.5"};

module.exports = MailInline;

MailInline.default = MailInline;
